import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CardButtonsComponent } from 'common/card/buttons/card-buttons.component';
import { DialogComponent } from 'common/dialog/dialog.component';
import {
  DialogFooterDirective,
  DialogHeaderTitleDirective,
} from 'common/dialog/dialog-slots.directive';
import { requiredAndNotWhitespaceOnly } from 'common/form/form.service';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutofocusDirective } from 'common/form/autofocus.directive';
import { ButtonDirective } from 'common/button/button.directive';

export interface FindingStateJustificationData {
  justification?: string;
  newStatus: string;
  previousStatus: string;
}

@Component({
  templateUrl: 'finding-state-justification.component.html',
  imports: [
    DialogComponent,
    CardButtonsComponent,
    DialogFooterDirective,
    DialogHeaderTitleDirective,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatError,
    MatInput,
    AutofocusDirective,
    ButtonDirective,
  ],
})
export class FindingStateJustificationComponent {
  private readonly dialogRef = inject(MatDialogRef<FindingStateJustificationComponent>);
  private readonly dialogData = inject<FindingStateJustificationData | null>(MAT_DIALOG_DATA, {
    optional: true,
  });
  private readonly formBuilder = inject(FormBuilder);

  protected readonly newStatus = signal<string | undefined>(this.dialogData?.newStatus);
  protected readonly previousStatus = signal<string | undefined>(this.dialogData?.previousStatus);
  protected readonly justification = signal<string | undefined>(this.dialogData?.justification);
  protected readonly justificationFormControlName = 'justification';

  form = signal<FormGroup>(
    this.formBuilder.group({
      justification: [
        this.justification(),
        [requiredAndNotWhitespaceOnly, Validators.maxLength(1024)],
      ],
    }),
  );

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close({
      newStatus: this.dialogData?.newStatus,
      justification: this.form().get(this.justificationFormControlName)?.value,
    });
  }
}
